var RecurringInvoiceEditView = require('./recurring-invoice-edit')

module.exports = RecurringInvoiceEditView.extend()
